import styled from 'styled-components';
import { Grid } from '@simplywallst/ui-core';

// Note
// sectionH2 and section are css variables
export const IntroductionV2Wrapper = styled(Grid)`
  counter-reset: sectionH2;
  margin: ${({ theme }) => theme.x2spacePx}px 0px;
`;

export const RecentUpdatesWrapper = styled(Grid)`
  background: ${({ theme }) => theme.color.phantom};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => theme.x2spacePx}px;
  width: 100%;
  height: 100%;
`;
